import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Logout } from 'assets/svg/icon-logout.svg'

function IconLogout(props: IconProps): JSX.Element {
  const title = 'icon-logout'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Logout {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconLogout
